import { render, staticRenderFns } from "./CourseDetailsForm.vue?vue&type=template&id=63797341&scoped=true"
import script from "./CourseDetailsForm.vue?vue&type=script&lang=js"
export * from "./CourseDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./CourseDetailsForm.vue?vue&type=style&index=0&id=63797341&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63797341",
  null
  
)

export default component.exports